// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: ang date strip — pag-render, date preselect/select,
// sarili nitong keyboard nav binding, at ang same-day countdown line (na
// naka-gate sa parehong date-availability checks na ginagamit ng strip).
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const CONFIG = DP.CONFIG;
  const state = DP.state;

  function formatCountdown(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const label = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
    return `${label} left for same-day delivery`;
  }

  // Live "Xh Ym left for same-day delivery" line under the section title.
  // Gate sa isDateSelectable(today) — sumasabay ito sa parehong range/cutoff/
  // blocked-date check na ginagamit ng date strip at ng slot status, kaya
  // hindi ito nagpapatuloy kapag naka-block ang "Today" (holiday/closure).
  // Naka-scope sa Today na napili sa picker (2026-09-01 owner decision) —
  // dating laging nakikita kahit anong petsa ang napili, na hindi relevant
  // sa customer kapag Sept 15 na ang selected date.
  function renderCountdown() {
    const { countdown, countdownText, dateInput } = state.elements;
    if (!countdown || !countdownText) return;

    const now = DP.getNowPH();
    const todayStr = now.format("YYYY-MM-DD");

    if (dateInput && dateInput.value && dateInput.value !== todayStr) {
      countdown.hidden = true;
      countdownText.textContent = "";
      return;
    }

    const availability = state.availability;
    if (!availability || !DP.isDateSelectable(todayStr, now)) {
      countdown.hidden = true;
      countdownText.textContent = "";
      return;
    }

    // Hakbang 3 (2026-09-02): window.cutoffAt versus Date.now() nang direkta —
    // walang lokal na cutoff computation, dayjs formatter na lang.
    const cutoffMs = Date.parse(availability.cutoffAt);
    const totalMinutes = Number.isFinite(cutoffMs)
      ? Math.floor((cutoffMs - Date.now()) / 60000)
      : 0;

    if (totalMinutes < 1) {
      countdown.hidden = true;
      countdownText.textContent = "";
      return;
    }

    countdownText.textContent = formatCountdown(totalMinutes);
    countdown.hidden = false;
  }

  function buildAriaLabelForDay(dateStr) {
    if (!dateStr) return "";
    const d = dayjs.tz(dateStr, "YYYY-MM-DD", CONFIG.timezone);
    return d.isValid() ? d.format("dddd, MMMM D, YYYY") : dateStr;
  }

  function getDateStripDays(now = DP.getNowPH()) {
    const minDate = DP.getMinSelectableDate(now);
    const todayStr = now.format("YYYY-MM-DD");
    const days = [];

    // Past-cutoff: keep Today visible (disabled) until the day actually ends,
    // so the strip explains "why not today" instead of silently starting tomorrow.
    if (minDate !== todayStr) days.push(todayStr);

    const futureCount = days.length ? 6 : 7;
    for (let i = 0; i < futureCount; i++) {
      days.push(
        dayjs.tz(minDate, "YYYY-MM-DD", CONFIG.timezone).add(i, "day").format("YYYY-MM-DD")
      );
    }

    return days;
  }

  function preselectDefaultDate(now = DP.getNowPH()) {
    const { dateInput } = state.elements;
    if (!dateInput || dateInput.value) return false;

    let candidate = DP.getMinSelectableDate(now);
    for (let i = 0; i < CONFIG.maxDays; i++) {
      if (DP.isDateSelectable(candidate, now)) break;
      candidate = dayjs
        .tz(candidate, "YYYY-MM-DD", CONFIG.timezone)
        .add(1, "day")
        .format("YYYY-MM-DD");
    }
    if (!DP.isDateSelectable(candidate, now)) return false;

    // Visual preselect only — no updateCart() POST until the shopper actually
    // picks a time slot, so plain page views never write cart attributes.
    dateInput.value = candidate;
    if (state.fpInstance) state.fpInstance.setDate(candidate, false);
    return true;
  }

  function selectDate(dateStr) {
    const { dateInput } = state.elements;
    if (!dateInput || dateInput.value === dateStr) return;

    dateInput.value = dateStr;

    if (state.fpInstance) {
      state.fpInstance.setDate(dateStr, false);
    }

    DP.toggleError(null);
    renderDateStrip();
    DP.renderTimeSlots(dateStr);
    DP.renderCountdown();
    DP.syncSelectorDisplays();
    void DP.updateCart(DP.buildCartPayload(), "date-strip");
  }

  function renderDateStrip() {
    const { dateStrip, dateInput, monthYearMeta } = state.elements;
    if (!dateStrip) return;

    const hadFocus = dateStrip.contains(document.activeElement);
    dateStrip.innerHTML = "";

    const now = DP.getNowPH();
    const todayStr = now.format("YYYY-MM-DD");
    const selectedDate = dateInput ? dateInput.value : "";
    let firstEnabledEl = null;
    let selectedEl = null;

    if (monthYearMeta) {
      const metaSource = dayjs.tz(selectedDate || todayStr, "YYYY-MM-DD", CONFIG.timezone);
      monthYearMeta.textContent = metaSource.isValid() ? metaSource.format("MMM YYYY") : "";
    }

    getDateStripDays(now).forEach((dateStr) => {
      const d = dayjs.tz(dateStr, "YYYY-MM-DD", CONFIG.timezone);
      const isToday = dateStr === todayStr;

      // A11y: ang accessible name ay dapat MAGSIMULA sa visible text ("Tue 12")
      // para pumasa sa WCAG 2.5.3 Label in Name (speech-input users).
      const visibleText = (isToday ? "Today" : d.format("ddd")) + " " + d.format("D");

      const el = document.createElement("div");
      el.className = "date-strip-day";
      if (isToday) el.classList.add("is-today");
      el.setAttribute("role", "option");
      el.setAttribute("aria-label", visibleText + ", " + buildAriaLabelForDay(dateStr));
      el.dataset.date = dateStr;

      const labelEl = document.createElement("span");
      labelEl.className = "date-strip-day__label";
      labelEl.textContent = isToday ? "Today" : d.format("ddd");

      const numEl = document.createElement("span");
      numEl.className = "date-strip-day__num";
      numEl.textContent = d.format("D");

      el.appendChild(labelEl);
      el.appendChild(numEl);

      if (!DP.isDateSelectable(dateStr, now)) {
        el.classList.add("is-disabled");
        if (isToday) {
          el.classList.add("is-cutoff");
          const isBlocked = DP.isDateBlocked(dateStr);
          const reason = isBlocked ? "unavailable for delivery" : "same-day cutoff passed";
          const title = isBlocked ? "Unavailable for delivery" : "Same-day cutoff passed";
          el.setAttribute("aria-label", visibleText + ", " + buildAriaLabelForDay(dateStr) + ", " + reason);
          el.setAttribute("title", title);

          // Visible "Cut-off" label (dating dot-lang indicator, hindi
          // nagpapaliwanag kung bakit disabled ang "Today"). Blocked-date
          // (holiday/closure) lang ang walang label dito — hindi tama ang
          // "Cut-off" para riyan, oras-based na term ito.
          if (!isBlocked) {
            const statusEl = document.createElement("span");
            statusEl.className = "date-strip-day__status";
            statusEl.textContent = "Cut-off";
            el.appendChild(statusEl);
          }
        }
        el.setAttribute("aria-disabled", "true");
        el.setAttribute("aria-selected", "false");
        el.setAttribute("tabindex", "-1");
      } else {
        el.setAttribute("aria-disabled", "false");
        el.setAttribute("tabindex", "-1");

        if (!firstEnabledEl) firstEnabledEl = el;

        if (dateStr === selectedDate) {
          el.classList.add("is-selected");
          el.setAttribute("aria-selected", "true");
          selectedEl = el;
        } else {
          el.setAttribute("aria-selected", "false");
        }

        el.addEventListener("click", () => selectDate(dateStr));
      }

      dateStrip.appendChild(el);
    });

    const tabbableEl = selectedEl || firstEnabledEl;
    if (tabbableEl) tabbableEl.setAttribute("tabindex", "0");

    if (hadFocus && tabbableEl) tabbableEl.focus();

    bindDateStripKeyboard(dateStrip);
  }

  function bindDateStripKeyboard(wrapper) {
    if (wrapper.dataset.deliveryKeyboardBound) return;
    wrapper.dataset.deliveryKeyboardBound = "true";

    wrapper.addEventListener("keydown", (event) => {
      const items = Array.from(wrapper.querySelectorAll(".date-strip-day:not(.is-disabled)"));
      if (!items.length) return;

      const focused = document.activeElement;
      let idx = items.indexOf(focused);
      if (idx === -1) idx = 0;

      let nextIdx = idx;

      switch (event.key) {
        case "ArrowRight":
          event.preventDefault();
          nextIdx = (idx + 1) % items.length;
          break;
        case "ArrowLeft":
          event.preventDefault();
          nextIdx = (idx - 1 + items.length) % items.length;
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          if (focused && focused.dataset.date) selectDate(focused.dataset.date);
          return;
        case "Home":
          event.preventDefault();
          nextIdx = 0;
          break;
        case "End":
          event.preventDefault();
          nextIdx = items.length - 1;
          break;
        default:
          return;
      }

      items.forEach((item, i) => {
        item.setAttribute("tabindex", i === nextIdx ? "0" : "-1");
      });
      items[nextIdx].focus();
      items[nextIdx].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
    });
  }

  DP.renderCountdown = renderCountdown;
  DP.buildAriaLabelForDay = buildAriaLabelForDay;
  DP.getDateStripDays = getDateStripDays;
  DP.preselectDefaultDate = preselectDefaultDate;
  DP.renderDateStrip = renderDateStrip;
})();
